/* eslint-disable */
export default {
  logging: 'ログ記録中...',
  logCall: '通話のログ記録',
  editLog: 'ログの編集',
  select: 'レコードを選択',
  OnHold: '保留中',
  Ringing: '呼び出し中',
  CallConnected: '通話を接続済み',
  unknownUser: '不明なユーザー',
  unknownNumber: '匿名',
  unavailable: '連絡不可',
  viewDetails: '詳細の表示',
  conferenceCall: '電話会議',
  callerId: '発信者番号',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
